"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _renderProps = require("../../../libs/renderProps");

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _typeGuards = require("@insided/deprecated-libs/typeGuards");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var RadioInputFilterSelector = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(RadioInputFilterSelector, _Component);

  var _super = _createSuper(RadioInputFilterSelector);

  function RadioInputFilterSelector() {
    var _this$props$selectedF, _this$props$selectedF2, _this$props$selectedF3;

    var _this;

    (0, _classCallCheck2.default)(this, RadioInputFilterSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      condition: (_this$props$selectedF = (_this$props$selectedF2 = _this.props.selectedFilterItems) === null || _this$props$selectedF2 === void 0 ? void 0 : _this$props$selectedF2.condition) !== null && _this$props$selectedF !== void 0 ? _this$props$selectedF : '',
      data: typeof ((_this$props$selectedF3 = _this.props.selectedFilterItems) === null || _this$props$selectedF3 === void 0 ? void 0 : _this$props$selectedF3.data) !== 'undefined' ? Number(_this.props.selectedFilterItems.data) : ''
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setCondition", function (condition) {
      var data = _this.state.data;

      _this.setState({
        condition: condition,
        data: data
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setData", function (data) {
      var condition = _this.state.condition;

      _this.setState({
        condition: condition,
        data: data
      });
    });
    return _this;
  }

  (0, _createClass2.default)(RadioInputFilterSelector, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          items = _this$props.items,
          children = _this$props.children;
      var _this$state = this.state,
          condition = _this$state.condition,
          data = _this$state.data;
      return (0, _preact.h)("div", null, (0, _preact.h)("div", {
        className: "overview__filters-box-content"
      }, items.map(function (item) {
        var checked = condition === item.value;
        return (0, _preact.h)("div", {
          key: item.id
        }, (0, _preact.h)(_InputGroup.default, {
          inline: true,
          qaClasses: "qa-filter-input-".concat(item.value),
          key: item.id,
          name: name,
          value: item.value,
          title: item.name,
          type: "radio",
          formGroupClasses: "overview__filters-box-filter",
          checked: checked,
          onChange: function onChange(e) {
            return _this2.setCondition(e.target.value);
          }
        }), checked && (0, _preact.h)(_InputGroup.default, {
          inline: true,
          qaClasses: "qa-radio-filter-input",
          name: name,
          value: data,
          title: id,
          type: "number",
          min: 0,
          formGroupClasses: "overview__filters-data-input",
          onKeyUp: function onKeyUp(e) {
            if ((0, _typeGuards.hasValueInEventTarget)(e)) {
              _this2.setData(e.target.value);
            }
          },
          onChange: function onChange(e) {
            return _this2.setData(e.target.value);
          }
        }));
      })), (0, _renderProps.extractRenderPropsChildren)(children)({
        data: _objectSpread(_objectSpread({}, this.state), {}, {
          data: Number(data)
        }),
        isApplyButtonDisabled: !condition || data === ''
      }));
    }
  }]);
  return RadioInputFilterSelector;
}(_preact.Component);

(0, _defineProperty2.default)(RadioInputFilterSelector, "create", function (config) {
  return _objectSpread({
    component: RadioInputFilterSelector,
    type: 'filter',
    getPillDisplayValue: function getPillDisplayValue(_ref) {
      var condition = _ref.condition,
          data = _ref.data;
      var item = config.items.find(function (i) {
        return i.value === condition;
      });
      return "".concat(item === null || item === void 0 ? void 0 : item.name, " ").concat(data);
    }
  }, config);
});
var _default = RadioInputFilterSelector;
exports.default = _default;